module.exports = __webpack_public_path__ + "static/img/May-23-2016-Schneider-whirlpool_23674.32e672b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/May-23-2016-Schneider-whirlpool_23674.jpg
// module id = RAI5
// module chunks = 0